import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate } from 'react-router-dom';

export default function EdiutProject() {
  const navigate = useNavigate();
  const active_pro_id = localStorage.getItem('selected_project_id');
  const [companyname, setCompanyname] = useState('');
  const [logedUserType, setLogedUserType] = useState('');
  useEffect(() => {
    let comname = localStorage.getItem('mem_company_name');
    setCompanyname(comname);
    var obj = {
      pro_id: active_pro_id
    }
    console.log(obj);
    fetch('getProjectOtherdetails.php', {
  method: 'POST',
  body: new URLSearchParams(obj)
})
.then(res => res.json())
.then(res => {
  console.log(res);

  if (res && res.length > 0) {

    $('#probname').val(res[0].pr_name ?? '');

    $('#requr').text(res[0].pr_requrmenrt ?? '');
    $('#edit_requr').val(res[0].pr_requrmenrt ?? '');

    $('#prodesc').text(res[0].pr_details ?? '');
    $('#edit_desc').val(res[0].pr_details ?? '');

    $('#protodo').text(res[0].pr_todo ?? '');
    $('#edit_todo').val(res[0].pr_todo ?? '');

    $('#startdate').text(res[0].pr_start_date ?? '');
    $('#edit_srt_date').val(res[0].pr_start_date ?? '');

    $('#enddate').text(res[0].deadline ?? '');
    $('#edit_end_date').val(res[0].deadline ?? '');

    $('#prosatus').text(res[0].pr_active_status ?? '');

  } else {
    console.log("No project details found");
  }
})
.catch(error => {
  console.error("Fetch Error:", error);
});
    const adminmember = localStorage.getItem('user_position');
    setLogedUserType(adminmember || 'Member');
  }, [])

  function showAlert(msg) {
    $('#alertpop').css('display', 'block');
    $('#alert_text').text(msg);
  }

  function closeAlert() {
    $('#alertpop').css('display', 'none');
    $('#alert_text').text('');
  }

  function converttoedit() {
    $('#probname').removeAttr('readonly');
    $('#probname').css({ 'border': '1px #7d7d7d solid', 'border-radius': '10px', 'padding': '10px' });
    $('#requr').css('display', 'none');
    $('#edit_requr').css({ 'display': 'block', 'border-radius': '10px', 'padding': '10px' });

    $('#prodesc').css('display', 'none');
    $('#edit_desc').css({ 'display': 'block', 'border-radius': '10px', 'padding': '10px' });

    $('#protodo').css('display', 'none');
    $('#edit_todo').css({ 'display': 'block', 'border-radius': '10px', 'padding': '10px' });

    $('#startdate').css('display', 'none');
    $('#edit_srt_date').css({ 'display': 'block', 'border-radius': '10px', 'padding': '10px' });

    $('#enddate').css('display', 'none');
    $('#edit_end_date').css({ 'display': 'block', 'border-radius': '10px', 'padding': '10px' });

    $('#activeedit').css('display', 'none');
    $('#inactiveedit').css('display', 'block');

    $('#updateproinfo').css('display', 'block');
  }

  function canceledit() {
    $('#probname').attr('readonly', 'true');
    $('#probname').css('border', '0');
    $('#requr').css('display', 'block');
    $('#edit_requr').css('display', 'none');

    $('#prodesc').css('display', 'block');
    $('#edit_desc').css('display', 'none');

    $('#protodo').css('display', 'block');
    $('#edit_todo').css('display', 'none');

    $('#startdate').css('display', 'block');
    $('#edit_srt_date').css('display', 'none');

    $('#enddate').css('display', 'block');
    $('#edit_end_date').css('display', 'none');

    $('#activeedit').css('display', 'block');
    $('#inactiveedit').css('display', 'none');

    $('#updateproinfo').css('display', 'none');
  }

  function updateProjectOtherDetails() {
    const active_pro_id = localStorage.getItem('selected_project_id');
    let pro_name = $('#probname').val();
    let pro_requrmenrt = $('#edit_requr').val();
    let pro_details = $('#edit_desc').val();
    let pro_todo = $('#edit_todo').val();
    let pro_start_date = $('#edit_srt_date').val();
    let pro_last_date = $('#edit_end_date').val();

    var obj = {
      pr_name: pro_name,
      pr_requrmenrt: pro_requrmenrt,
      pr_details: pro_details,
      pr_todo: pro_todo,
      pr_start_date: pro_start_date,
      pr_last_date: pro_last_date,
      pro_id: active_pro_id
    }

    console.log(obj);
    $.ajax({
      type: 'POST',
      url: 'updateProjectOtherdetails.php',
      data: obj,
      cache: false,
      success: function (result) {
        var res = result;


        if (res !== 'fail') {
          showAlert('Project details updated successfully].');
          setTimeout(rediredirectdetails, 1500)
        } else {
          showAlert('Cannot find any details for this project.');
        }
      },
      error: function (xhr, status, error) {
        console.error("AJAX Error:", status, error, xhr.responseText);
      }
    });
  }

  function rediredirectdetails() {
    localStorage.setItem('initialpage', 'editproject');
    navigate('/redirect_task');
  }
  return (
    <div>
      <div className='topbar_menu proedittop'>
        <h3>Company name : {companyname}</h3>
         {(logedUserType !=='Member') && (
          <>
        <button className='member_button  proeditbtn' id="activeedit" onClick={converttoedit}>Edit Details</button>
        <button className='member_button  proeditbtn nodisplay' id="inactiveedit" onClick={canceledit}>Cancel Edit</button>
        </>
         )}

      </div>
      <div className='one_half_middle'>
        <div className='details_section'>
          <p className='sectionlabel'>Project name: </p>
          <input type="text" id="probname" readOnly />
        </div>
        <div className='details_section'>
          <p className='sectionlabel'>Project Requirement: </p>
          <p id="requr"></p>
          <textarea id="edit_requr"></textarea>
        </div>
        <div className='details_section'>
          <p className='sectionlabel'>Project Description: </p>
          <p id="prodesc"></p>
          <textarea id="edit_desc"></textarea>
        </div>

        <div className='details_section'>
          <p className='sectionlabel'>Project Todo list: </p>
          <p id="protodo"></p>
          <textarea id="edit_todo"></textarea>
        </div>
        <div className='details_section'>
          <p className='sectionlabel'>Project Start date: </p>
          <p id='startdate'></p>
          <input type="date" id="edit_srt_date" />
        </div>
        <div className='details_section'>
          <p className='sectionlabel'>Project End date: </p>
          <p id="enddate"></p>
          <input type="date" id="edit_end_date" />
        </div>
        <div className='details_section'>
          <p className='sectionlabel'>Project Status: </p>
          <p id='prosatus'></p>

        </div>
        <div className='details_section'>
          <button className='editButton' id="updateproinfo" onClick={updateProjectOtherDetails}>Update</button>
        </div>
      </div>
      <div className='vl_dsh_popup' id="alertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="alert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeAlert}>Okay</button>
          </div>
        </div>
      </div>
    </div>
  )
}
